<router-outlet></router-outlet>
<ubi-chat [attr.api-url]="seeplyApiUrl" [attr.api-key]="seeplyApiKey"></ubi-chat>
